module.exports = __webpack_public_path__ + "img/1511527549.5db472da.jpg";